module.exports = __webpack_public_path__ + "img/nidalee.e061c854.jpg";